import React, { useState } from 'react';

/**
 * PIN認証テンキー
 * correctPin: 正解のPIN（4桁文字列）
 * childName / childAvatar: 表示用
 * onSuccess: 認証成功コールバック
 * onCancel: キャンセルコールバック
 */
export default function PinAuth({ correctPin, childName, childAvatar, onSuccess, onCancel }) {
  const [input, setInput] = useState('');
  const [shake, setShake] = useState(false);
  const [hint, setHint]   = useState('');

  const handleKey = (digit) => {
    if (input.length >= 4) return;
    const next = input + digit;
    setInput(next);
    if (next.length === 4) {
      if (next === correctPin) {
        onSuccess();
      } else {
        setShake(true);
        setHint('ちがうよ！もういちど');
        setTimeout(() => {
          setInput('');
          setShake(false);
          setHint('');
        }, 800);
      }
    }
  };

  const handleDelete = () => {
    setInput((prev) => prev.slice(0, -1));
    setHint('');
  };

  return (
    <div className="screen pin-screen">
      {onCancel && (
        <button className="auth-back-btn" onClick={onCancel}>← もどる</button>
      )}

      <div className="pin-title">
        {childAvatar && <span style={{ fontSize: 48 }}>{childAvatar}</span>}
        <h2 style={{ margin: '8px 0 4px', fontSize: 20, color: '#2E1065' }}>
          {childName || 'ひみつナンバー'}
        </h2>
        <p className="pin-subtitle">ひみつナンバーを　いれてね</p>
      </div>

      {/* ドット表示 */}
      <div className={`pin-dots ${shake ? 'shake' : ''}`}>
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`pin-dot ${i < input.length ? 'filled' : ''}`} />
        ))}
      </div>

      {hint && <p className="pin-hint">{hint}</p>}

      {/* テンキー */}
      <div className="pin-keypad">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', '⌫'].map((k, idx) => (
          <button
            key={idx}
            className={`pin-key ${k === '' ? 'invisible' : ''}`}
            onClick={() => k === '⌫' ? handleDelete() : k !== '' && handleKey(k)}
            disabled={k === ''}
          >
            {k}
          </button>
        ))}
      </div>
    </div>
  );
}
